import { render, staticRenderFns } from "./DraggableCollection.vue?vue&type=template&id=54ce41c2&"
import script from "./DraggableCollection.vue?vue&type=script&lang=js&"
export * from "./DraggableCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports